/**
 * DPos
 * API for DPos
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { View } from './view';


export interface ModelAndView { 
    empty?: boolean;
    model?: object;
    modelMap?: { [key: string]: object; };
    reference?: boolean;
    status?: ModelAndView.StatusEnum;
    view?: View;
    viewName?: string;
}
export namespace ModelAndView {
    export type StatusEnum = 'ACCEPTED' | 'ALREADY_REPORTED' | 'BAD_GATEWAY' | 'BAD_REQUEST' | 'BANDWIDTH_LIMIT_EXCEEDED' | 'CHECKPOINT' | 'CONFLICT' | 'CONTINUE' | 'CREATED' | 'DESTINATION_LOCKED' | 'EXPECTATION_FAILED' | 'FAILED_DEPENDENCY' | 'FORBIDDEN' | 'FOUND' | 'GATEWAY_TIMEOUT' | 'GONE' | 'HTTP_VERSION_NOT_SUPPORTED' | 'IM_USED' | 'INSUFFICIENT_SPACE_ON_RESOURCE' | 'INSUFFICIENT_STORAGE' | 'INTERNAL_SERVER_ERROR' | 'I_AM_A_TEAPOT' | 'LENGTH_REQUIRED' | 'LOCKED' | 'LOOP_DETECTED' | 'METHOD_FAILURE' | 'METHOD_NOT_ALLOWED' | 'MOVED_PERMANENTLY' | 'MOVED_TEMPORARILY' | 'MULTIPLE_CHOICES' | 'MULTI_STATUS' | 'NETWORK_AUTHENTICATION_REQUIRED' | 'NON_AUTHORITATIVE_INFORMATION' | 'NOT_ACCEPTABLE' | 'NOT_EXTENDED' | 'NOT_FOUND' | 'NOT_IMPLEMENTED' | 'NOT_MODIFIED' | 'NO_CONTENT' | 'OK' | 'PARTIAL_CONTENT' | 'PAYLOAD_TOO_LARGE' | 'PAYMENT_REQUIRED' | 'PERMANENT_REDIRECT' | 'PRECONDITION_FAILED' | 'PRECONDITION_REQUIRED' | 'PROCESSING' | 'PROXY_AUTHENTICATION_REQUIRED' | 'REQUESTED_RANGE_NOT_SATISFIABLE' | 'REQUEST_ENTITY_TOO_LARGE' | 'REQUEST_HEADER_FIELDS_TOO_LARGE' | 'REQUEST_TIMEOUT' | 'REQUEST_URI_TOO_LONG' | 'RESET_CONTENT' | 'SEE_OTHER' | 'SERVICE_UNAVAILABLE' | 'SWITCHING_PROTOCOLS' | 'TEMPORARY_REDIRECT' | 'TOO_EARLY' | 'TOO_MANY_REQUESTS' | 'UNAUTHORIZED' | 'UNAVAILABLE_FOR_LEGAL_REASONS' | 'UNPROCESSABLE_ENTITY' | 'UNSUPPORTED_MEDIA_TYPE' | 'UPGRADE_REQUIRED' | 'URI_TOO_LONG' | 'USE_PROXY' | 'VARIANT_ALSO_NEGOTIATES';
    export const StatusEnum = {
        Accepted: 'ACCEPTED' as StatusEnum,
        AlreadyReported: 'ALREADY_REPORTED' as StatusEnum,
        BadGateway: 'BAD_GATEWAY' as StatusEnum,
        BadRequest: 'BAD_REQUEST' as StatusEnum,
        BandwidthLimitExceeded: 'BANDWIDTH_LIMIT_EXCEEDED' as StatusEnum,
        Checkpoint: 'CHECKPOINT' as StatusEnum,
        Conflict: 'CONFLICT' as StatusEnum,
        Continue: 'CONTINUE' as StatusEnum,
        Created: 'CREATED' as StatusEnum,
        DestinationLocked: 'DESTINATION_LOCKED' as StatusEnum,
        ExpectationFailed: 'EXPECTATION_FAILED' as StatusEnum,
        FailedDependency: 'FAILED_DEPENDENCY' as StatusEnum,
        Forbidden: 'FORBIDDEN' as StatusEnum,
        Found: 'FOUND' as StatusEnum,
        GatewayTimeout: 'GATEWAY_TIMEOUT' as StatusEnum,
        Gone: 'GONE' as StatusEnum,
        HttpVersionNotSupported: 'HTTP_VERSION_NOT_SUPPORTED' as StatusEnum,
        ImUsed: 'IM_USED' as StatusEnum,
        InsufficientSpaceOnResource: 'INSUFFICIENT_SPACE_ON_RESOURCE' as StatusEnum,
        InsufficientStorage: 'INSUFFICIENT_STORAGE' as StatusEnum,
        InternalServerError: 'INTERNAL_SERVER_ERROR' as StatusEnum,
        IAmATeapot: 'I_AM_A_TEAPOT' as StatusEnum,
        LengthRequired: 'LENGTH_REQUIRED' as StatusEnum,
        Locked: 'LOCKED' as StatusEnum,
        LoopDetected: 'LOOP_DETECTED' as StatusEnum,
        MethodFailure: 'METHOD_FAILURE' as StatusEnum,
        MethodNotAllowed: 'METHOD_NOT_ALLOWED' as StatusEnum,
        MovedPermanently: 'MOVED_PERMANENTLY' as StatusEnum,
        MovedTemporarily: 'MOVED_TEMPORARILY' as StatusEnum,
        MultipleChoices: 'MULTIPLE_CHOICES' as StatusEnum,
        MultiStatus: 'MULTI_STATUS' as StatusEnum,
        NetworkAuthenticationRequired: 'NETWORK_AUTHENTICATION_REQUIRED' as StatusEnum,
        NonAuthoritativeInformation: 'NON_AUTHORITATIVE_INFORMATION' as StatusEnum,
        NotAcceptable: 'NOT_ACCEPTABLE' as StatusEnum,
        NotExtended: 'NOT_EXTENDED' as StatusEnum,
        NotFound: 'NOT_FOUND' as StatusEnum,
        NotImplemented: 'NOT_IMPLEMENTED' as StatusEnum,
        NotModified: 'NOT_MODIFIED' as StatusEnum,
        NoContent: 'NO_CONTENT' as StatusEnum,
        Ok: 'OK' as StatusEnum,
        PartialContent: 'PARTIAL_CONTENT' as StatusEnum,
        PayloadTooLarge: 'PAYLOAD_TOO_LARGE' as StatusEnum,
        PaymentRequired: 'PAYMENT_REQUIRED' as StatusEnum,
        PermanentRedirect: 'PERMANENT_REDIRECT' as StatusEnum,
        PreconditionFailed: 'PRECONDITION_FAILED' as StatusEnum,
        PreconditionRequired: 'PRECONDITION_REQUIRED' as StatusEnum,
        Processing: 'PROCESSING' as StatusEnum,
        ProxyAuthenticationRequired: 'PROXY_AUTHENTICATION_REQUIRED' as StatusEnum,
        RequestedRangeNotSatisfiable: 'REQUESTED_RANGE_NOT_SATISFIABLE' as StatusEnum,
        RequestEntityTooLarge: 'REQUEST_ENTITY_TOO_LARGE' as StatusEnum,
        RequestHeaderFieldsTooLarge: 'REQUEST_HEADER_FIELDS_TOO_LARGE' as StatusEnum,
        RequestTimeout: 'REQUEST_TIMEOUT' as StatusEnum,
        RequestUriTooLong: 'REQUEST_URI_TOO_LONG' as StatusEnum,
        ResetContent: 'RESET_CONTENT' as StatusEnum,
        SeeOther: 'SEE_OTHER' as StatusEnum,
        ServiceUnavailable: 'SERVICE_UNAVAILABLE' as StatusEnum,
        SwitchingProtocols: 'SWITCHING_PROTOCOLS' as StatusEnum,
        TemporaryRedirect: 'TEMPORARY_REDIRECT' as StatusEnum,
        TooEarly: 'TOO_EARLY' as StatusEnum,
        TooManyRequests: 'TOO_MANY_REQUESTS' as StatusEnum,
        Unauthorized: 'UNAUTHORIZED' as StatusEnum,
        UnavailableForLegalReasons: 'UNAVAILABLE_FOR_LEGAL_REASONS' as StatusEnum,
        UnprocessableEntity: 'UNPROCESSABLE_ENTITY' as StatusEnum,
        UnsupportedMediaType: 'UNSUPPORTED_MEDIA_TYPE' as StatusEnum,
        UpgradeRequired: 'UPGRADE_REQUIRED' as StatusEnum,
        UriTooLong: 'URI_TOO_LONG' as StatusEnum,
        UseProxy: 'USE_PROXY' as StatusEnum,
        VariantAlsoNegotiates: 'VARIANT_ALSO_NEGOTIATES' as StatusEnum
    };
}


